module.exports = __webpack_public_path__ + "img/6.7129a0ff.svg";